var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyTasks({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-My_Tasks"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "My_Tasks",
    "data-name": "My Tasks",
    clipPath: "url(#clip-My_Tasks)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18254",
    "data-name": "Path 18254",
    d: "M72.2,19.483H60.478c-.015-.01-.03-.026-.047-.029a1.973,1.973,0,0,1-1.6-2.019c.015-4.648.006-9.3.007-13.945A1.917,1.917,0,0,1,60.808,1.5c.323,0,.647,0,.97,0H62.6a4.99,4.99,0,0,1,.008-.7A1.313,1.313,0,0,1,62.8.263c.081-.119.249-.178.379-.263H69.5a.841.841,0,0,1,.611.949c-.012.175,0,.352,0,.548h.223c.513,0,1.027,0,1.54,0a1.94,1.94,0,0,1,2,2.025q0,5.324,0,10.648c0,1.109,0,2.218,0,3.328a1.836,1.836,0,0,1-.789,1.6A4.921,4.921,0,0,1,72.2,19.483ZM62.6,3.042a.524.524,0,0,0-.085-.021c-.545,0-1.091,0-1.636,0-.382,0-.514.134-.514.516q0,6.954,0,13.908c0,.389.126.517.511.517h10.96c.367,0,.508-.138.508-.5q0-6.964,0-13.927c0-.368-.139-.508-.5-.51-.52,0-1.04,0-1.56,0-.055,0-.109.008-.174.012,0,.225,0,.434,0,.643a.773.773,0,0,1-.835.848q-2.921,0-5.842,0a.765.765,0,0,1-.83-.83C62.6,3.478,62.6,3.264,62.6,3.042Zm5.98-1.51h-4.44V2.987h4.44Z",
    transform: "translate(-55.35 1.258)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18255",
    "data-name": "Path 18255",
    d: "M101.246,79.351c0,.222,0,.436,0,.65a.765.765,0,0,0,.83.83q2.921,0,5.842,0a.773.773,0,0,0,.835-.848c0-.209,0-.418,0-.643.064,0,.119-.012.174-.012.52,0,1.04,0,1.56,0,.363,0,.5.142.5.51q0,6.964,0,13.927c0,.366-.141.5-.508.5H99.521c-.384,0-.511-.128-.511-.517q0-6.954,0-13.908c0-.382.132-.515.514-.516.545,0,1.091,0,1.636,0A.525.525,0,0,1,101.246,79.351Zm2.763,9.344c-.149-.158-.25-.272-.358-.379-.358-.36-.714-.721-1.077-1.076a.762.762,0,1,0-1.064,1.087c.611.617,1.228,1.23,1.842,1.844a.79.79,0,0,0,1.282-.007l3.781-3.781a2.2,2.2,0,0,0,.168-.181.75.75,0,0,0-.362-1.188.786.786,0,0,0-.841.25q-1.611,1.618-3.227,3.231A1.792,1.792,0,0,0,104.009,88.7Z",
    transform: "translate(-93.997 -75.051)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18256",
    "data-name": "Path 18256",
    d: "M202.656,40.276V41.73h-4.44V40.276Z",
    transform: "translate(-189.427 -37.485)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18257",
    "data-name": "Path 18257",
    d: "M160.527,231.479a1.8,1.8,0,0,1,.145-.2q1.613-1.616,3.227-3.231a.786.786,0,0,1,.841-.25.75.75,0,0,1,.362,1.188,2.205,2.205,0,0,1-.168.181l-3.781,3.781a.79.79,0,0,1-1.282.007c-.615-.614-1.231-1.226-1.842-1.844a.762.762,0,1,1,1.064-1.087c.363.355.719.716,1.077,1.076C160.277,231.208,160.378,231.321,160.527,231.479Z",
    transform: "translate(-150.514 -217.835)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyTasks);
export default __webpack_public_path__ + "static/media/My Tasks.de18ed599cddd53c43447533f98149bf.svg";
export { ForwardRef as ReactComponent };